import { createApp } from 'vue'
import { Modal } from 'bootstrap'
import QuoteRequestForm from './components/QuoteRequestForm'
import productDto from './product-dto'

window.arno = window.arno || {}

const app = createApp({
  mixins: [productDto],
  data() {
    return {
      productCategory: window.arno.productCategory || null,
      items: JSON.parse((window.localStorage.getItem('toolbox') || '{}')),
    }
  },
  components: {
    QuoteRequestForm
  },
  mounted() {

    // Listen for our custom event for adding products to the toolbox.
    window.addEventListener('addToToolbox', (e) => {
      console.log(e.detail)
      this.addToToolbox(e.detail.product)
    })

    // Setup the modal.
    this.modal = Modal.getOrCreateInstance(document.getElementById('toolbox'))
  },
  computed:  {
    numItems() {
      return Object.keys(this.items).length
    }
  },
  watch: {
    items: {
      deep: true,
      handler(items) {
        window.localStorage.setItem('toolbox', JSON.stringify(items))
      }
    }
  },
  methods: {
    /**
     * Get an item by id.
     */
    getItem(productId) {
      return this.items[productId]
    },
    /**
     * Add a product to the toolbox, 
     * or increment the quantity if already added.
     */
    addToToolbox(product) {
      let quantity = 1
      
      // Already in cart, so increment quantity.
      if (this.items[product.id]) {
        quantity = parseInt(this.items[product.id].quantity) + 1
      }

      const projectDto = this.getProductDto(this.productCategory.title, product, quantity)

      this.items[product.id] = projectDto

      this.modal.show()
    },
    /**
     * Update an item's quantity.
     */
    updateQuantity(e) {
      let productId = e.target.dataset.productId
      let quantity = e.target.value
      
      if (quantity == 0) {
        this.removeFromToolbox(productId)
        return
      }

      let product = Object.assign({}, this.getItem(productId))
      product.quantity = parseInt(quantity)

      this.items[productId] = product
    },
    /**
     * Remove a product from the toolbox.
     */
    removeFromToolbox(productId) {
      delete this.items[productId]
    },
    /**
     * Get the item title for display.
     */
    getItemTitle(item) {
      let attributes = item.attributes
      let output = ''

      // EDP
      for (let attribute in attributes) {
        if (attribute == 'EDP') {
          output += ('EDP: ' + attributes[attribute])
        }
      }

      // Part Number
      for (let attribute in attributes) {
        if (attribute == 'Part Number') {
          output += (' ' + attributes[attribute])
        }
      }

      return output
    },
    /**
     * Format an items attributes.
     */
    formatItemAttributes(item) {
      let attributes = item.attributes
      let output = []

      for (let attribute in attributes) {
        if (attribute != 'UUID') {
          output.push('<b>' + attribute + '</b>: ' + attributes[attribute])
        }
      }

      return output.join(', ')
    },
  }
})

app.mount('#toolbox')
